import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuthentication } from 'shared/hooks/useAuthentication';
import { Button } from './Button';

export const LogoutButton: FC = () => {
  const { t } = useTranslation();
  const { logout, logoutLoading } = useAuthentication();
  return (
    <Button
      loading={logoutLoading}
      variant="text"
      className="!text-sm text-white hover:!text-white/80 sm:text-primary sm:hover:enabled:!text-primary-600 sm:active:enabled:!text-primary-700"
      onClick={logout}
    >
      {t('action:logout')}
    </Button>
  );
};
